// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.markdown-help-popover {
  margin-left: 4px;
  vertical-align: top;
  align-self: center;
}
.markdown-help-popover__content {
  max-height: calc(100vh - 34px);
  overflow: hidden;
}
.markdown-help-popover__tooltip {
  max-width: 300px;
}
.markdown-help-popover__tooltip_hidden {
  display: none;
}
.markdown-help-popover_mobile svg {
  width: 18px;
  height: 18px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/MarkdownHelpPopover/MarkdownHelpPopover.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,mBAAA;EACA,kBAAA;AACJ;AACI;EACI,8BAAA;EACA,gBAAA;AACR;AAEI;EACI,gBAAA;AAAR;AAEQ;EACI,aAAA;AAAZ;AAII;EACI,WAAA;EACA,YAAA;AAFR","sourcesContent":[".markdown-help-popover {\n  margin-left: 4px;\n  vertical-align: top;\n  align-self: center;\n}\n.markdown-help-popover__content {\n  max-height: calc(100vh - 34px);\n  overflow: hidden;\n}\n.markdown-help-popover__tooltip {\n  max-width: 300px;\n}\n.markdown-help-popover__tooltip_hidden {\n  display: none;\n}\n.markdown-help-popover_mobile svg {\n  width: 18px;\n  height: 18px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
